import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18 15-6-6-6 6" }));
export default SvgChevron;
